import store from '@/store'
import i18n from '@/libs/i18n'
import useErrorManager from '@/composable/useErrorManager'
import useModalDialog from '@/composable/useModalDialog'
import useArticlesList from '../article/useArticlesList'

export default function useVideosList() {
  const articleVideoEntity = useArticlesList('video')
  const errorManager = useErrorManager()
  const modal = useModalDialog()

  const deleteItem = id => {
    modal({
      title: i18n.t('general.delete'),
      message: i18n.t('general.areYouSure'),
    }).then(res => {
      if (!res) return undefined
      return store
        .dispatch('crud/delete', {
          queryParams: { lang: articleVideoEntity.currentLanguage.value },
          data: { id },
          endpoint: 'articles/search',
        })
        .then(() => {
          articleVideoEntity.refTable.value.refetchData()
        })
        .catch(err => {
          errorManager(err)
        })
    })
  }

  return {
    ...articleVideoEntity,
    deleteItem,
  }
}
